import { ModelBase, NeoModel, Rules } from "@singularsystems/neo-core";

@NeoModel
export default class RawGenericExportMappingLookup extends ModelBase {

    public rawGenericExportMappingId: number = 0;

    public staticExportColumnSpecId: number = 0;

    public staticServiceProviderFileGroupingId: number = 0;

    @Rules.StringLength(100)
    public displayName: string = "";

    public serviceProviderGroupingName: string = "";

    public columnName: string = "";

    public fileType: string = "";

    public activeStartDate: Date | null = null;

    public activeEndDate: Date | null = null;

    public exportName: string = "";

    public isExcluded: boolean = false;
}